import React, { useEffect, useState } from 'react';
import { Box, Typography, Dialog, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import useStyles from './useStyles';
import { getUserTransferInventory } from '../../../apis/product';
import Loading from '../../Loading';
import CustomTable from '../../UI/CustomTable';
import { CellType } from '../../../types/Common';
import { getTransferDetail } from '../../../apis/payment';
import CustomPagination from '../../UI/CustomPagination';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'name',
    label: 'نام',
    type: CellType.STRING,
  },
  {
    key: 'lastName',
    label: 'نام خانوادگی',
    type: CellType.STRING,
  },
  {
    key: 'mobileNumber',
    label: 'شماره موبایل',
    type: CellType.MOBILE,
  },
];

const useStyle = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
    direction: 'rtl',
  },
}));

interface InfoKnowledgeDialogProps {
  openUsersUsedProduct: boolean;
  closeDialog: () => void;
  transferCode: string | unknown;
  haseInventory?: boolean;
}

const UsersUsedProduct: React.FC<InfoKnowledgeDialogProps> = (props) => {
  const { openUsersUsedProduct, closeDialog, transferCode, haseInventory } = props;
  const styles = useStyle();
  const classes = useStyles();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableHeadState, setTableHeadState] = useState(tableHead);

  const handleClose = () => closeDialog();

  const getUsersUsedProductsData = () => {
    setLoading(true);

    if (haseInventory) {
      getUserTransferInventory(transferCode)
        .then((res: any) => {
          setUsers(res || []);
          setTotalPages(res.pagination?.totalPages || 1);
        })
        .catch((e) => console.log({ e }))
        .finally(() => setLoading(false));
    } else {
      getTransferDetail(transferCode, currentPage, rowsPerPage)
        .then((res: any) => {
          setUsers(res.data || []);
          setTotalPages(res.pagination?.totalPages || 1);
        })
        .catch((e) => console.log({ e }))
        .finally(() => setLoading(false));
    }
  };

  const UserStateAction = (row: any) => {
    const { state } = row || {};

    if (state === 0 || state === 1)
      return (
        <Box className={classes.badgeContainer}>
          <Box className={classes.badge} bgcolor={state === 0 ? 'secondary.main' : 'success.dark'}>
            <Typography color='white' fontSize='x-small'>
              {state === 0 ? 'تست انجام نشده' : 'تست انجام شده'}
            </Typography>
          </Box>
        </Box>
      );
    return;
  };

  useEffect(() => {
    if (openUsersUsedProduct && transferCode) getUsersUsedProductsData();
  }, [currentPage, rowsPerPage, openUsersUsedProduct]);

  useEffect(() => {
    if (haseInventory) {
      const statusObject = {
        key: 'state',
        label: 'وضعیت تست',
        type: CellType.ACTION,
        action: UserStateAction,
      };

      setTableHeadState([...tableHead, statusObject]);
    }
  }, [setTableHeadState]);

  return (
    <Dialog
      onClose={handleClose}
      open={openUsersUsedProduct}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className={classes.mainDialog}>
        <Box className={classes.header}>
          <Typography color='text.main' fontWeight='bold'>
            جزئیات انتقال به کاربران
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Box mb={2} mt={1}>
          {loading ? (
            <Loading fullHeight={false} />
          ) : (
            <>
              <CustomTable rows={users} tableHead={tableHeadState} loading={false} />

              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onChangeCurrentPage={(page: number) => setCurrentPage(page)}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={(rowsPerPage: number) => {
                  if (currentPage !== 0) setCurrentPage(1);
                  setRowsPerPage(rowsPerPage);
                }}
              />
            </>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default UsersUsedProduct;
